import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { isNative } from "../../lib/platform";

export function MobileFrame({ children }: { children: ReactNode }) {
  const native = isNative();
  const { pathname } = useLocation();
  // /admin/* is a desktop-first surface — the phone-frame is too cramped
  // for tables and edit forms. data-wide flips the styling in styles.css
  // so the host fills the viewport on these routes.
  const wide = pathname.startsWith("/admin");
  return (
    <div
      className="ma-frame-host"
      data-native={native ? "true" : "false"}
      data-wide={wide ? "true" : "false"}
    >
      <div className="ma-frame">{children}</div>
    </div>
  );
}
